import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import './assets/fonts/font.css'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
// import BaiduMap from 'vue-baidu-map'
import api from './api'
import VueI18n from 'vue-i18n'
import LangENUS from './assets/lang/en-us.js'
import LangZHCN from './assets/lang/zh-cn.js'

Vue.use(VideoPlayer)

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh-cn',
  messages: {
    'en-us': LangENUS,
    'zh-cn': LangZHCN
  }
})

Vue.prototype.$api = api

import {VueJsonp} from 'vue-jsonp'
Vue.use(VueJsonp)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

//路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

Vue.use(Antd)

// Vue.use(BaiduMap, {
//   ak: 'XRmUL1UdNqlStWef4o6WcZTFMeTO2fV0'
// })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
